var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model.images && _vm.model.images.length)?_c('b-img-lazy',_vm._b({attrs:{"src":_vm.model.images[0]}},'b-img-lazy',_vm.image_props,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }